const Datastore = require('./BaseDatastore');

class BaseCurrentEntryDatastore extends Datastore {

}

const CurrentEntryDatastore = new BaseCurrentEntryDatastore();
module.exports = CurrentEntryDatastore;